import { Platform } from 'react-native';
import EncryptedStorage from 'react-native-encrypted-storage';

/**
 * «Сохранять метаданные снимка» (стори 13.11). Выключено по умолчанию: файл,
 * отправленный в режиме «Оригинал», иначе несёт координаты съёмки и модель
 * камеры, а этого никто не просил.
 */
const KEY = 'svyaz_photo_keep_metadata';

function isWeb(): boolean {
  return Platform.OS === 'web';
}

/**
 * Стори 18.1. Настройка читается из хранилища асинхронно, а переключатель рисуется синхронно —
 * из-за этого он при каждом открытии настроек на мгновение показывал «выключено» и только потом
 * прыгал в настоящее положение. Держим последнее известное значение в памяти, как это уже
 * сделано у тактильной отдачи (`util/haptics`): до первого чтения действует умолчание,
 * дальше — то, что выбрал человек.
 */
let cached = false;

/** Синхронное значение для интерфейса. Точное после {@link primeKeepPhotoMetadataPref}. */
export function isKeepPhotoMetadata(): boolean {
  return cached;
}

/** Один раз на старте приложения — чтобы к открытию настроек значение уже было верным. */
export async function primeKeepPhotoMetadataPref(): Promise<void> {
  cached = await readKeepPhotoMetadata();
}

export async function readKeepPhotoMetadata(): Promise<boolean> {
  try {
    const raw = isWeb()
      ? (globalThis.localStorage?.getItem(KEY) ?? null)
      : await EncryptedStorage.getItem(KEY);
    cached = raw === '1';
    return cached;
  } catch {
    return false;
  }
}

export async function writeKeepPhotoMetadata(keep: boolean): Promise<void> {
  const value = keep ? '1' : '0';
  // В память — сразу: следующий рендер настроек и следующая отправка снимка должны видеть выбор,
  // не дожидаясь записи в хранилище.
  cached = keep;
  try {
    if (isWeb()) {
      globalThis.localStorage?.setItem(KEY, value);
      return;
    }
    await EncryptedStorage.setItem(KEY, value);
  } catch {
    /* noop: неудача записи не должна ломать отправку */
  }
}
